const Reducer = (state, action) => {
  switch (action.type) {
    case "SET_HEADER":
      return {
        ...state,
        headerTitle: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;
